import React from 'react';
import { useTranslation } from 'react-i18next';

import { mutationEditorQuestionCreate } from 'gql/mutations/editor';

import Empty from './Empty';

const EmptyContainer = (props) => {
  const { t } = useTranslation();
  return (
    <Empty
      handleQuestionCreate={mutationEditorQuestionCreate}
      t={t}
      {...props}
    />
  );
};

export default EmptyContainer;
